var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResultTableComponent',{staticClass:"ml-5 mr-5 mb-5",attrs:{"keyword":_vm.keyword,"filterByItemCodes":true}})}
var staticRenderFns = []

export { render, staticRenderFns }